import {ArrowLeftIcon, Button, DeleteIcon, DragIcon, EditIcon} from '@kit';

import React from 'react';

import css from './gallery.module.css';

type Props = {
	onEdit: () => void;
	onDelete: () => void;
	/** без обработчика кнопки нет */
	onMoveLeft?: () => void;
	onMoveRight?: () => void;
	/** пропсы ручки перетаскивания; без них ручки нет */
	dragHandle?: React.ComponentProps<typeof Button>;
	className?: string;
};

export const GalleryImageToolbar: React.FC<Props> = ({onEdit, onDelete, onMoveLeft, onMoveRight, dragHandle, className}) => (
	<div className={className || css.adminToolbar}>
		{dragHandle && (
			<Button
				appearance="transparent"
				size="small"
				icon={<DragIcon />}
				draggable
				className={css.handle}
				aria-label="Перетащить"
				title="Перетащить, чтобы изменить порядок"
				{...dragHandle}
			/>
		)}
		{onMoveLeft && (
			<Button
				appearance="transparent"
				size="small"
				icon={<ArrowLeftIcon />}
				onClick={onMoveLeft}
				aria-label="Сдвинуть влево"
				title="Сдвинуть влево"
			/>
		)}
		{onMoveRight && (
			<Button
				appearance="transparent"
				size="small"
				icon={<ArrowLeftIcon className={css.flip} />}
				onClick={onMoveRight}
				aria-label="Сдвинуть вправо"
				title="Сдвинуть вправо"
			/>
		)}
		<Button
			appearance="transparent"
			size="small"
			icon={<EditIcon />}
			onClick={onEdit}
			aria-label="Изменить"
			title="Изменить подпись и автора"
		/>
		<Button
			appearance="transparent"
			size="small"
			icon={<DeleteIcon />}
			onClick={onDelete}
			aria-label="Убрать из галереи"
			title="Убрать из галереи"
		/>
	</div>
);
